import { BaseEntity } from "./BaseEntity";

export default class Organization extends BaseEntity {

    constructor(id: number, public name: string) {
        super(id);
    }

}